"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _computeTimezoneGroups = _interopRequireDefault(require("../helpers/computeTimezoneGroups"));

var _TimezoneAliases = _interopRequireDefault(require("../lists/TimezoneAliases"));

var cachedTimezoneGroups;
var previousLocale;

var _default = function _default() {
  if (_I18n.default.locale === previousLocale) {
    return cachedTimezoneGroups;
  } else {
    var timezoneAliases = (0, _TimezoneAliases.default)();
    previousLocale = _I18n.default.locale;
    cachedTimezoneGroups = (0, _computeTimezoneGroups.default)(timezoneAliases);
    return cachedTimezoneGroups;
  }
};

exports.default = _default;
module.exports = exports.default;